<template>
    <div class="page-container">
        <div class="tabbox">
            <div class="tabs">
                <div class="tab-item" :class="{actived:currentTab == 0}" @click="changeTab(0)">获取记录</div>
                <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">兑换记录</div>
            </div>
        </div>
        <!-- 获取记录 -->
        <template v-if="currentTab == 0">
            <div class="record-types">
                <div class="type-item" :class="{actived:filterType == 0}" @click="changeFilter(0)">全部</div>
                <div class="type-item" :class="{actived:filterType == 1}" @click="changeFilter(1)">待释放</div>
                <div class="type-item" :class="{actived:filterType == 2}" @click="changeFilter(2)">已释放</div>
                <!-- <div class="type-item" v-for="(item,index) in pageData.listTwo" :key="index" :class="{actived:filterType == item}" @click="changeFilter(item)">{{filterList[item]}}</div> -->
            </div>
            <div class="referral-line">
                <span>已释放：¥{{recommendTotal}}</span>
                <span>待释放：¥{{recommendRelease}}</span>
            </div>
            <div class="record-list">
                <div class="record-item" v-for="(item,index) in gotList" :key="index">
                    <div class="item-type">
                        <template v-if="item.type == 2">
                            <div class="type-icon bu">补</div>
                            <div class="type-text bu">补款</div>
                        </template>
                        <template v-else>
                            <div class="type-icon">推</div>
                            <div class="type-text">推荐</div>
                        </template>
                    </div>
                    <div class="item-info">
                        <div class="item-top">
                            <div class="item-count">{{item.amount}}</div>
                            <div class="item-status waiting">{{item.status == 1 ? '待释放' : '已释放'}}</div>
                        </div>
                        <div class="item-bottom">
                            <span>{{item.from}}</span>
                            <span>{{item.createTime | createtimeNotime}}</span>
                        </div>
                    </div>
                </div>
                <div class="no-more" v-show="gotList.length > 0">没有更多了</div>
            </div>
            <!-- 数据为空 -->
            <van-empty v-show="gotList.length == 0" :image=nullImg description="暂无数据~" />
        </template>
        <!-- 兑换记录 -->
        <template v-else>
            <div class="referral-line" style="padding-top:15px;">
                <span>总兑换成功金额：¥{{recommendUsed}}</span>
            </div>
            <div class="incentive-list">
                <div class="incentive-item" v-for="(item,index) in dhList" :key="index" @click="jumpDetail(item.orderId)">
                    <div class="item-top">
                        <span class="date">{{item.createTime | formatCreatetime}}</span>
                        <span class="status" :class="{waiting : item.status != 10}">{{item.status == 10 ? '兑换成功' : '待确认'}}</span>
                    </div>
                    <div class="goods-info-block" v-for="(gitem,gindex) in item.goodsList" :key="gindex">
                        <img :src="gitem.picUrl" class="goods-pic">
                        <div class="goods-detail">
                            <div class="goods-name">{{`${gitem.name} ${gitem.degree}度 ${gitem.capacity}`}}</div>
                            <div class="goods-sku">
                                <span>{{gitem.unit == '箱' ? '整箱(6瓶)' : '单瓶'}}</span>
                                <span style="color:#3088f5;">x{{gitem.num}}({{gitem.unit}})</span>
                            </div>
                            <div class="caigou-price">采购价：¥{{gitem.price}}/瓶</div>
                        </div>
                    </div>
                    <div class="item-bottom">总价：¥{{item.amount}}</div>
                </div>
            </div>
            <!-- 数据为空 -->
            <van-empty v-show="dhList.length == 0" :image=nullImg description="暂无数据~" />
        </template>
    </div>
</template>
<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast,Empty} from 'vant'

export default {
    data(){
        return {
            currentTab:0,//0 获取记录，1 兑换记录
            filterType:0,//0 所有
            page:1,
            limit:50,
            filterList:{
                "1":"成为高级合伙人",
                "2":"补款",
                "3":"津贴划转入账",
                "4":"津贴提现",
                "5":"进货",
                "6":"推荐高级合伙人",
                "7":"推荐初级合伙人",
                "8":"被推荐人补款",
                "9":"兑换",
                "10":"成为合伙人"
            },
            pageData:{},
            gotList:[],
            dhList:[],
            recommendTotal:0,
            recommendRelease:0,
            recommendUsed:0,
            nullImg:require('@/assets/icon-null.png'),
        }
    },
    components:{
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.recommendTotal=this.$route.params.recommendTotal;
        this.recommendRelease=this.$route.params.recommendRelease;
        this.recommendUsed=this.$route.params.recommendUsed;
        this.getData();
    },
    methods:{
        changeTab(tab){
            this.currentTab=tab;
            this.getData();
        },
        changeFilter(type){
            this.filterType=type;
            this.gotList=[];
            this.getData();
        },
        getData(){
            if(this.currentTab == 0){//获取记录
                $http({
                    method:'post',
                    data:{
                        accountType:2,//1 账户，2 推荐奖励，3 津贴
                        opType:1,
                        status:this.filterType,
                        page:this.page,
                        limit:this.limit
                    },
                    url:config.api.getduihuanRecord
                }).then(res=>{
                    if(res.errno == 0){
                        this.pageData=res.data;
                        this.gotList=res.data.list;
                    }else{
                        Toast(res.errmsg);
                    }
                })
            }else{
                $http({
                    method:'post',
                    data:{
                        page:this.page,
                        limit:this.limit
                    },
                    url:config.api.dhRecord
                }).then(res=>{
                    if(res.errno == 0){
                        this.dhList=res.data;
                    }else{
                        Toast(res.errmsg);
                    }
                })
            }
        },
        jumpDetail(oid){
            this.$router.push({
                name:'redemption-detail',
                params:{
                    orderId:oid
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    background:#f5f5f5;
    box-sizing: border-box;
    padding: 0 10px;
    padding-top: 65px;
    padding-bottom: 30px;
    min-height: calc(100vh);
    .tabbox{
        position: fixed;
        background: #fff;
        top:0;
        left:0;
        width:100vw;
        height:65px;
        box-sizing: border-box;
        padding: 12px 38px;
        .tabs{
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            .tab-item{
                width:50%;
                height:40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color:#2172F6;
                box-sizing: border-box;
                border:1px solid #3088F5;
                &.actived{
                    color:#fff;
                    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
                    border:none;
                }
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    border-right: none;
                }
                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-left: none;
                }
            }
        }
    }
    .record-types{
        padding:15px 0;
        // height:56px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .type-item{
            height:26px;
            line-height: 26px;
            padding:0 12px;
            color:#999;
            background: #fff;
            font-size: 13px;
            margin-right: 15px;
            &:last-child{
                margin-right: 0;
            }
            @media screen and (max-width: 750px){
                border-radius: 26px;
            }
            &.actived{
                background:#328DF7;
                color:#fff;
            }
        }
    }
    .referral-line{
        font-size: 14px;
        color:#666;
        line-height: 20px;
        &>span{
            margin-right: 20px;
        }
    }
    .record-list{
        background: #fff;
        padding:0 20px;
        margin-top: 10px;
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        .record-item{
            padding:15px 0;
            border-bottom: 1px solid #f5f5f5;
            &:last-child{
                border:none;
            }
            @include flex-between();
            .item-type{
                text-align: center;
                padding-top: 6px;
                .type-icon{
                    width:22px;
                    height:18px;
                    line-height: 18px;
                    background:#56E9E2;
                    color:#fff;
                    font-size: 11px;
                    margin-bottom: 2px;
                    border-radius: 2px;
                    &.bu{
                        background: #9D92FB;
                    }
                }
                .type-text{
                    line-height: 16px;
                    color:#56E9E2;
                    font-size: 11px;
                    &.bu{
                        color:#9D92FB;
                    }
                }
            }
            .item-info{
                width:275px;
                .item-top{
                    @include flex-between();
                    line-height: 25px;
                    margin-bottom: 5px;
                    .item-count{
                        font-size: 18px;
                        color:#333;
                        font-weight: 400;
                        font-family: PingFangSC-Regular, PingFang SC;
                    }
                    .item-status{
                        font-size: 15px;
                        color:#666;
                        &.waiting{
                            color:#FFA11F;
                        }
                    }
                }
                .item-bottom{
                    @include flex-between();
                    line-height: 18px;
                    color:#999;
                    font-size: 12px;
                    &>span:first-child{
                        max-width: 190px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
        .no-more{
            padding:15px 0;
            color:#999;
            font-size: 12px;
            text-align: center;
        }
    }
    .incentive-list{
        margin-top: 10px;
        .incentive-item{
            background:#fff;
            border-radius: 4px;
            padding:0 15px;
            margin-bottom: 10px;
            .item-top{
                @include flex-between();
                height:44px;
                line-height: 44px;
                color:#999;
                border-bottom: 1px solid #f5f5f5;
                .date{
                    font-size: 13px;
                }
                .status{
                    font-size: 14px;
                    &.waiting{
                        color:#FFA820;
                    }
                }
            }
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                padding:15px 0;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-between();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .item-bottom{
                text-align: right;
                color:#333;
                font-size: 14px;
                line-height: 20px;
                padding-bottom: 15px;
            }
        }
    }
}
</style>